export default {"src":"/_next/static/media/gamingLogo2.e155c8db.svg","height":60,"width":300,"blurWidth":0,"blurHeight":0};